import {
  Box,
  Center,
  Circle,
  Grid,
  GridItem,
  Heading,
  HStack,
  Image,
  Link,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { AiFillGithub, AiFillLinkedin, AiOutlineMail } from "react-icons/ai";
import { BsFillTelephoneFill, BsWhatsapp } from "react-icons/bs";
import avatar from "../Images/avatar.jpg"
// const snippet = `function greet(name) {
//   return 'Hello ' + name;
// }

// console.log(greet('John'));`;
const typerContent = "Full Stack Web Developer ";
let timer;
//let counter=0
export default function Home() {
  const [charBag, setCharBag] = useState("");
  const [counter, setCounter] = useState(0);
  if (charBag.length === typerContent.length + 1) {
    timer = setTimeout(() => {
      setCharBag(typerContent);
      setCounter(counter + 1);
      // console.log('This will run after 1 second!')
    }, 1000);
  }
  //console.log(counter)
  if (counter >= 12) {
    clearTimeout(timer);
  }
  if (charBag.length === typerContent.length) {
    timer = setTimeout(() => {
      setCharBag(typerContent + "!");
      // console.log('This will run after 1 second!')
    }, 1000);
  }

  useEffect(() => {
    //let time=200
    let count = 0;
    const interval = setInterval(() => {
      let bag = "";
      for (let i = 0; i < count; i++) {
        bag += typerContent[i];
      }
      setCharBag(bag);
      if (count === typerContent.length) {
        clearInterval(interval);
      }
      count++;
    }, 200);

    return () => clearInterval(interval);

    return () => clearTimeout(timer);
  }, []);
  // console.log(charBag);
  return (
    <Box pt={{ base: "10px", lg: "50px" }}>
      <Grid
        spacing={{ base: "10px", lg: "50px" }}
        m={{ base: "5px", lg: "30px" }}
        templateColumns={{ base: "auto", md: "70% 30%" }}
       
      >
       
          <VStack
          
            fontSize={["10px", "15px", "20px", "30px", null, "50px"]}
            spacing={["10px", "20px", "30px", "40px"]}
          >
            <VStack spacing={{ base: "10px", lg: "20px" }}>
              <HStack>
                <Text display="inline" color="gray">
                  Hello !
                </Text>
                <Text pl={{ base: "10px", lg: "20px" }} color="tomato">
                  I am Madhukar,
                </Text>
              </HStack>
              <Heading
                color="tomato"
                size={["xs", "sm", "md", "lg", "xl", "2xl"]}
              >
                {charBag}
              </Heading>
            </VStack>
            <Box fontSize={["xs", null, "sm", null, "lg"]}>
              <Heading size={["xs", "sm", null, "md"]} pb="15px">
                A Creative Full stack web developer
              </Heading>

              <Text>
                " Designing your digital presence with innovation and
                excellence. "
              </Text>
              <Text>
                Ambitious Full stack developer with problem solving and
                analyzing skills and dedicated to my work.
              </Text>
            </Box>
            <HStack
              fontSize={["lg", "xl", "2xl", "3xl"]}
              justifyItems="start"
              alignItems="center"
              gap="25px"
              mt="25px"
            >
              <Link href="mailto:kakadem.b.99@gmail.com" isExternal>
                <Circle
                  size={[ "40px",null,null, null, "50px"]}
                  bg="#D44638"
                  color="white"
                >
                  <AiOutlineMail />
                </Circle>
              </Link>

              <Link
                href="https://www.linkedin.com/in/madhukar-kakade-767b8a89"
                isExternal
              >
                <Circle
                  size={[ "40px",null,null, null, "50px"]}
                  bg="#0077B5"
                  color="white"
                >
                  <AiFillLinkedin />
                </Circle>
              </Link>

              <Link href="https://github.com/madhukarkakade" isExternal>
                <Circle
                  size={[ "40px",null,null, null, "50px"]}
                  bg="black"
                  color="white"
                >
                  <AiFillGithub />
                </Circle>
              </Link>

              <Link
                href="https://wa.me/8446058359"
                title="8208080454"
                isExternal
              >
                <Circle
                  size={[ "40px",null,null, null, "50px"]}
                  bg="green"
                  color="white"
                >
                  <BsWhatsapp />
                </Circle>
              </Link>
            </HStack>
          </VStack>
     
        <GridItem ml={{ base: "5px", lg: "20px" }} pt="30px"  >
          <Image src="https://ca.slack-edge.com/T049JC010P9-U04ARFKMAHL-92937c2b8633-512" borderRadius="lg"></Image>
        </GridItem>
      </Grid>
    </Box>
  );
}
